<template>
  <AppSection
    id="mail-credentials"
    type="section"
    :title="$getConst.pages.mail_credentials.mail_credentials_page_title"
    :is-section-loading="isStarting"
    :button="true"
    :button-icon-svg="$getConst.svgIcons.wifi_sky_blue"
    button-variant="outline"
    button-size="lg"
    :first-button-tooltip="$t($getConst.pages.connectivity_test.test_smtp_status)"
    @onClick="testSMTP"
  >
    <b-row class="justify-content-center mb-4 pt-4">


        <b-col cols="12" class="text-center">
          <a @click="loginSMTP" :class="{'disabled': isSigningInToSmtp}">
            <AppSvgIcon
              id="ms-button"
              type="button"
              class="mt-3 mt-sm-0 btn"
              :class="{'ms-button-active': false}"
              height="41"
              grow-by-height
              :icon="$getConst.svgIcons.microsoft_big"
            />
            <b-badge v-if="false" id="success-badge" variant="success" pill class="w-auto px-1"><i :class="$getConst.icons.check"/></b-badge>
          </a>
          <hr>
        </b-col>

      <template v-if="isOauth2Connected">
        <b-col sm="6">
          <b-form-group  id="mail-host" :label="$t($getConst.pages.mail_credentials.mail_host_label) + ' *'" label-for="mail-host-input">
            <b-form-input
              id="mail-host-input"
              :disabled="true"
              v-model.trim="$v.mailCredentialsToEdit.mail_host.$model"
              :class="{ 'is-invalid': $v.mailCredentialsToEdit.mail_host.$error }"
              :placeholder="$t($getConst.pages.mail_credentials.mail_host_placeholder) + ' *'"
              size="lg"
              required
            ></b-form-input>
            <AppFormFeedback :errors="$v.mailCredentialsToEdit.mail_host"/>
          </b-form-group>
        </b-col>


        <b-col sm="6">
          <b-form-group  id="mail-port" :label="$t($getConst.pages.mail_credentials.mail_port_label) + ' *'" label-for="mail-port-input">
            <b-form-input
              id="mail-port-input"
              :disabled="true"
              v-model.trim="$v.mailCredentialsToEdit.mail_port.$model"
              :class="{ 'is-invalid': $v.mailCredentialsToEdit.mail_port.$error }"
              :placeholder="$t($getConst.pages.mail_credentials.mail_port_placeholder) + ' *'"
              size="lg"
              required
            ></b-form-input>
            <AppFormFeedback :errors="$v.mailCredentialsToEdit.mail_port"/>
          </b-form-group>
        </b-col>

        <b-col sm="6">
          <b-form-group  id="mail-username" :label="$t($getConst.pages.mail_credentials.mail_username_label) + ' *'" label-for="mail-username-input">
            <b-form-input
              id="mail-username-input"
              :disabled="true"
              v-model.trim="$v.mailCredentialsToEdit.mail_username.$model"
              :class="{ 'is-invalid': $v.mailCredentialsToEdit.mail_username.$error }"
              :placeholder="$t($getConst.pages.mail_credentials.mail_username_placeholder) + ' *'"
              size="lg"
              required
            ></b-form-input>
            <AppFormFeedback :errors="$v.mailCredentialsToEdit.mail_username"/>
          </b-form-group>
        </b-col>
        <b-col sm="6"></b-col>
      </template>

</b-row>
  </AppSection>
</template>

<script>
  import AppSection from "../../../../components/common/sections/AppSection";
  import AppConfirmButtons from "../../../../components/common/utils/AppConfirmButtons";
  import AppFormFeedback from "../../../../components/common/form/AppFormFeedback";
  import {
    getMailCredentialsByScope,
    testScopeMailCredentials,
    updateSMTPTokens
  } from "../../../../api/mailCredentials.api";
  import {snotifyConfig} from "../../../../shared/constants/snotify";
  import MailCredentialsForm from "./MailCredentialsForm";
  import {integer, required} from "vuelidate/lib/validators";
  export default {
    name: "index",
    components: {MailCredentialsForm, AppFormFeedback, AppConfirmButtons, AppSection},
    props: {
      scope_id: null
    },
    computed: {
      isOauthActivated() {
        return this.mailCredentials && this.mailCredentials.isOauth;
      }
    },
    data() {
      return {
        mailCredentials: null,
        isStarting: false,
        isLoading: false,
        selectedDetails: null,
        isSigningInToSmtp: false,
        isOauth2Connected: false,
        mailCredentialsToEdit: {
          id: null,
          mail_host: null,
          mail_port: null,
          mail_username: null,
          mail_password: null,
          token: null,
          refresh_token :null
        },

      }
    },
    validations: {
      mailCredentialsToEdit: {
        mail_host: {required},
        mail_port: {required, integer},
        mail_username: {required},
        mail_password: {},
      }
    },
    methods: {
      selectDetails(authType) {
        if (this.selectedDetails === authType) {
          this.selectedDetails = null;
          this.$root.$emit('bv::toggle::collapse', 'img-collapse');
        } else {
          if (this.selectedDetails === null) {
            this.$root.$emit('bv::toggle::collapse', 'img-collapse');
          }
          this.selectedDetails = authType;
        }
      },
      setMailCredentials(credentials) {
        this.mailCredentials = credentials;
      },
      setLoading(isLoading) {
        this.isLoading = isLoading;
      },
      getMailCredentials() {
        this.isStarting = true;
        getMailCredentialsByScope(this.scope_id).then(
          (response) => {
            this.mailCredentials = Object.assign({}, response.data);
            this.isStarting = false;
            if (location.hash.includes("success")) {
              this.selectDetails("oauth2");
              history.replaceState(null, null, " ");
            }
            this.updateMailCredentialsToEdit()

          },
          (error) => {
            this.handleApiError(error);
            this.isStarting = false;
          }
        )
      },
      updateMailCredentialsToEdit() {
        if (this.mailCredentials.isOauth) {
          this.isOauth2Connected = true;
          this.mailCredentialsToEdit = Object.assign({}, this.mailCredentials);
        } else {
          this.isOauth2Connected = false;
          this.mailCredentialsToEdit = {
            id: this.mailCredentials.id,
            mail_host: "smtp.office365.com",
            mail_port: 587,
            mail_username: null,
            mail_password: null,
          }
        }
      },
      loginSMTP() {
        this.isSigningInToSmtp = true;
        this.$emit("isLoading", true);
        this.isLoading = true;

        let currentUri = location.href.replace(location.hash,"");
        currentUri = currentUri.replace("#","");
        location.replace(updateSMTPTokens(this.scope_id, currentUri));
      },
      testSMTP() {
        this.$snotify.async(
          this.$t(this.$getConst.pages.connectivity_test.smtp_request_sending),
          this.$t(this.$getConst.pages.alerts.please_wait),
          () => new Promise((resolve, reject) => {
            testScopeMailCredentials(this.scope_id).then(
              () => {
                resolve({
                  title: this.$t(this.$getConst.pages.alerts.success),
                  body: this.$t(this.$getConst.pages.connectivity_test.smtp_success_message),
                  config: snotifyConfig,
                })
              },
              () => {
                reject({
                  title: this.$t(this.$getConst.pages.alerts.error),
                  body: this.$t(this.$getConst.pages.connectivity_test.smtp_failure_message),
                  config: snotifyConfig
                })
              }
            )
          })
        )
      },

    },
    created() {
      if (location.hash.includes("error")) {
        history.replaceState(null, null, " ");
        this.$snotify.error(
          this.$options.filters.capitalize(this.$t(this.$getConst.pages.alerts.unknown_error)),
          this.$t(this.$getConst.pages.alerts.error_code)+" B23"
        );
      } else if(location.hash.includes("success")) {
        this.$snotify.success(this.$t(this.$getConst.pages.alerts.success_operation));
      }
      this.getMailCredentials();
    }
  }
</script>

<style scoped lang="scss">
  .active-icon-wrapper {
    margin: 0;
    position: absolute;
    top: -10px;
    right: -15px
  }
  .active-icon {
    box-shadow: 0 0.313rem 0.8rem rgba(122, 123, 151, .5), 0 0.126rem 0.225rem rgba(122, 123, 151, .3);
    overflow: hidden;
    display: block;
    width: 44px;
    height: 44px;
    line-height: 44px;
    -webkit-transition: all .2s ease-in-out;
    transition: all .2s ease-in-out;
    opacity: 1;
    border-radius: 50px;
  }
  .card-active {
    border: 1px solid #28a745;
    background: #28a7452e;
  }
  #success-badge {
    margin-left: -9px;
    margin-top: 0px;
    position: absolute;
  }
</style>
